module.exports = "/_next/static/images/IMG_3024-dcbf3bc048a56370bf9dd3409cfc4f54.jpg";